import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { NetworkCallService } from '../../../core/services/network-call.service';
import { fromSignupSetPasscodeActions } from '../actions';
import { ISignupSetPasscode, ISignupSetPasscodeResponse } from '../models/signup-set-passcode.model';
import { HelpersService } from '../../../core/services/helpers.service';

@Injectable()
export class SignupSetPasscodeEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  signupSetPasscodeRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromSignupSetPasscodeActions.loadSignupSetPasscodes),
      switchMap(action =>
        this.networkCallService
          .post<ISignupSetPasscode, ISignupSetPasscodeResponse>('/Authentication/businessSignupsetpasscode', action.request)
          .pipe(
            map(response => {
              if (response.passcodeToWeak && !response.success) {
                this.helperService.notifyError(`Your passcode is too weak`, 300, 3000);
              } else if (!response.passcodeToWeak && response.success && response.firstLogin) {
                this.router.navigateByUrl('auth/marketing-options');
              } else if (!response.passcodeToWeak && response.success && !response.firstLogin) {
                this.router.navigateByUrl('businesses');
              }
              return fromSignupSetPasscodeActions.loadSignupSetPasscodesSuccess({ response });
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(fromSignupSetPasscodeActions.loadSignupSetPasscodesFailure(error));
            })
          )
      )
    )
  );
}
